import axiosInstance from "./axiosInstance";

export const settingsServices = {
  async getSettings() {
    try {
      const response = await axiosInstance.get("/settings");
      return response.data;
    } catch (error) {
      console.error("Error get settings for user:", error);
      throw error;
    }
  },
  async saveSettings(settings) {
    try {
      const response = await axiosInstance.post("/settings", {
        settings,
      });
      return response.data;
    } catch (error) {
      console.error("Error change settings for user:", error);
      throw error;
    }
  },
  async pingBot() {
    try {
      const response = await axiosInstance.post("/settings/ping");
      return response.data;
    } catch (error) {
      console.error("Error pinging bot:", error);
      throw error;
    }
  },
  async getNotebook() {
    try {
      const response = await axiosInstance.get("/settings/notebook");
      return response.data;
    } catch (error) {
      console.error("Error getting notebook:", error);
      throw error;
    }
  },
  async saveNotebook(notebook) {
    try {
      const response = await axiosInstance.put("/settings/notebook", {
        notebook,
      });
      return response.data;
    } catch (error) {
      console.error("Error saving notebook:", error);
      throw error;
    }
  },
};
